import react, { useReducer, useMemo, useContext, useEffect } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { Box, FormControl, InputLabel, Select, MenuItem, TextField, IconButton, Tooltip } from '@mui/material'
import Table from '../../Table'
import { DatePicker } from '@mui/x-date-pickers'
import { number2dayweek } from '../../Utils/dayjsptbrhelper'
import dayjs from 'dayjs'
import { customTheme } from '../../theme/textfieldTheme';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import ColorButton from '../../Buttons/ColorButton'
import { externalComponent } from '../../AppRoutes'
import { api } from '../../../services/api'
import PasswordIcon from '@mui/icons-material/Password';
import SyncIcon from '@mui/icons-material/Sync';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import toast from 'react-hot-toast'
//import ConfirmationDialog from '../../Information/ConfirmationDialog'
import ConfirmationDialog from '../../Utils/ConfirmationDialog'
import EditUsers from './edit'
import { PatternFormat } from 'react-number-format';

const getcolumns = (state, setState) => {
    const rowmap = Object.fromEntries(state.sellers.map(row => ([row.id, row])))
    const enterprisemap = Object.fromEntries(state.enterprises.map(row => ([row.id, row])))
    const columns = []
    columns.push({ field: 'username', headerName: 'Usuário', flex: 1 })
    columns.push({ field: 'seller', headerName: 'Vendedor', flex: 1, renderCell: ({ value }) => rowmap[value]?.seller?.label })
    columns.push({ field: 'enterprises', headerName: 'Empresa', width: 80, 
        renderCell: ({value}) => (value || '').split(',').map(e => enterprisemap[e]?.label || '').join(', ') })
    columns.push({ field: 'email', headerName: 'Email', flex: 1 })
    columns.push({
        field: 'telephone', headerName: 'Telefone', flex: 1, renderCell: ({ value }) =>
            <PatternFormat
                format="(##) #####-####"
                allowEmptyFormatting
                mask=" "
                value={value}
                displayType="text"
            />
    })
    columns.push({ field: 'groups', headerName: 'Grupos', flex: 1 })
    columns.push({
        field: 'active', headerName: 'Status', width: 60,
        renderCell: ({ value }) => value ? <CheckCircleOutlineIcon color='success' /> : <CancelIcon color='error' />
    })
    columns.push({
        field: 'actions', headerName: 'Ações', width: 150,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Ressincronizar'><IconButton onClick={() => { setState({ resync: props.row }) }}><SyncIcon /></IconButton></Tooltip>
                    <Tooltip title='Resetar senha'><IconButton onClick={() => { setState({ reset: props.row }) }}><PasswordIcon /></IconButton></Tooltip>
                    <Tooltip title='Editar'><IconButton onClick={() => { setState({ edit: props.row }) }}><EditIcon /></IconButton></Tooltip>
                </Box >
            )
        }
    }
    )

    return columns
}

const requestData = async (state, setState, setLoader, returnValue = false) => {

    let url = `/representantes/?status=${state.status}`

    setLoader(true)
    const res = await api.get(url)
    if (res.status === 200) {
        if (returnValue) return res.data
        setState({
            rows: res.data
        })
    } else if (res.status === 400) {
        toast.error(res.data)
    }

    setLoader(false)
}

const requestEnterprises = async (setState) => {

    let url = `/frete/filiais`

    const res = await api.post(url)
    if (res.status === 200) {
        return res.data
    } else {
        toast.error(res.data)
    }
    return []

}

const requestGroups = async (setState) => {

    let url = `/representantes/grupos/`

    const res = await api.get(url)
    if (res.status === 200) {
        return res.data

    } else {
        toast.error(res.data)
    }
    return []
}

const requestSellers = async (setState) => {

    let url = `/vendedores/`

    const res = await api.get(url)
    if (res.status === 200) {
        return res.data

    } else {
        toast.error(res.data)
    }
    return []
}

const initialize = async (state, setState, setLoader) => {

    setLoader(true)
    const [sellers, groups, enterprises, rows] = await Promise.all([
        requestSellers(), 
        requestGroups(), 
        requestEnterprises(), 
        requestData(state, setState, () => { }, true)])
    setState({
        sellers: sellers,
        groups: groups,
        enterprises: enterprises,
        rows: rows
    })
    setLoader(false)
}

const sincronize = async (state, setState, setLoader, user = null) => {

    const payload = {}

    if (user)
        payload.user = user.id

    setLoader(true)
    const res = await api.post(`/representantes/recalibrar/`, payload)
    if (res.status === 200) {
        await requestData(state, setState, setLoader)
        toast.success('Usuário(s) elevor sincronizado(s).')
    } else if (res.status === 400) {
        toast.error(res.data)
    }

    setLoader(false)
}

const resetPassword = async (setLoader, user) => {

    setLoader(true)
    const res = await api.post(`/representantes/resetar_senha/`, { user: user.id })
    if (res.status === 200) {
        toast.success('Senha do usuáro foi resetada e ele receberá a senha por e-mail.')
    } else if (res.status === 400) {
        toast.error(res.data)
    }

    setLoader(false)
}

const submitUsers = async (state, setState, setLoader) => {
    setLoader(true)

    let res = null

    if (state.id)
        res = await api.patch('/representantes/' + state.id + '/', state)
    else
        res = await api.post('/representantes/', state)
    if ([200, 201].includes(res.status)) {
        setState({ edit: false })
        toast.success('Usuário salvo com sucesso')
    } else {
        toast.error('Houve um erro para salvar os dados')
    }

    setLoader(false)
}


const UsersElevor = () => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        status: true,
        edit: null,
        reset: null,
        resync: null,
        resync_all: null,
        enterprises: [],
        groups: [],
        rows: [],
        sellers: []
    })

    useEffect(() => {
        initialize(state, setState, setLoader)
    }, [])

    const outerTheme = useTheme();

    return (
        <>
            {state.edit &&
                <EditUsers
                    data={state.edit}
                    submit={(data) => {
                        submitUsers(data, setState, setLoader).then(() => requestData(state, setState, setLoader));
                    }}
                    handleClose={() => setState({ edit: null })}
                    enterprises={state.enterprises}
                    groups={state.groups}
                    sellers={state.sellers}
                />}
            {state.resync_all &&
                <ConfirmationDialog
                    open={true}
                    content='Deseja sincronizar os usuários da Elevor?'
                    onConfirm={() => { state.resync_all(); setState({ resync_all: null }) }}
                    handleClose={() => setState({ resync_all: null })}
                />}

            {state.resync &&
                <ConfirmationDialog
                    open={true}
                    content={<>Deseja sincronizar o usuário {state.resync.username}?</>}
                    onConfirm={() => { sincronize(state, setState, setLoader, state.resync); setState({ resync: null }) }}
                    handleClose={() => setState({ resync: null })}
                />}

            {state.reset &&
                <ConfirmationDialog
                    open={true}
                    content={<>Deseja resetar a senha do usuário {state.reset.username}?</>}
                    onConfirm={() => { resetPassword(setLoader, state.reset); setState({ reset: null }) }}
                    handleClose={() => setState({ reset: null })}
                />}
            <Box className='nfsentrada-mainframe'>
                <ThemeProvider theme={customTheme(outerTheme)}>
                    <Box sx={{ flex: .15 }} className='nfsentrada-filters'>
                        <Box className='filter-items'>
                            <FormControl sx={{ width: '13rem' }} size="small">
                                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Status"
                                    value={state.status}
                                    onChange={(e) => setState({ status: e.target.value })}
                                >
                                    {
                                        Object.entries(
                                            {
                                                'true': 'Ativo',
                                                'false': 'Inativo'
                                            }
                                        ).map(([key, value]) => (
                                            <MenuItem key={key} value={key}>{value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Box>
                        <Box className='filter-buttons'>
                            <ColorButton onClick={() => setState({ resync_all: () => sincronize(state, setState, setLoader) })}>
                                Sincronizar
                            </ColorButton>
                            <ColorButton onClick={() => requestData(state, setState, setLoader)}>
                                Localizar
                            </ColorButton>
                            {/* <ColorButton onClick={() => setState(initial_state)}>
                                Limpar filtros
                            </ColorButton> */}
                        </Box>
                    </Box>
                </ThemeProvider>
                <Box sx={{ flex: .85, overflow: 'hidden' }}>
                    <Table
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={useMemo(() => getcolumns(state, setState), [state.rows, state.edit])}
                        pagination={false}
                        disableRowSelectionOnClick
                        toolbar
                        slots={{
                            filterComponent: true,
                            columnComponent: true,
                            addComponent: () => setState({ edit: {} })
                        }}
                        density='compact'
                        rowHeight={30}
                    />
                </Box>
            </Box>
        </>
    )

}

export default UsersElevor